import { useMutation } from '@apollo/client';
import { useRouter } from 'next/router';

import { CreateChatDirectConversationDocument } from '@website/types/graphqlOperations';

/**
 * Create a conversation and redirect
 */
export default function useCreateConversationAndRedirect(
  from: string,
  to: string,
  // If redirecting to the host, we need a hostURL
  hostURL?: string,
) {
  const router = useRouter();

  const [createConversation] = useMutation(
    CreateChatDirectConversationDocument,
  );

  async function createChannelAndRedirect() {
    const { data } = await createConversation({
      variables: { input: { from, to } },
    });

    const conversationID = data.createChatDirectConversation.id;

    // redirect to the inbox
    router.push(
      hostURL
        ? `/hosts/dashboard/${hostURL}/messages/${conversationID}`
        : `/me/${from}/messages/${conversationID}`,
    );
  }

  return createChannelAndRedirect;
}
